export default function UploadHeader() {
  return (
    <div className="upload-header">
      <h1>증거 이미지 업로드</h1>
      <p>
        AI가 피싱·스캠 위험도를 자동으로 판단해 드려요
        <br />
        의심스러운 채팅이나 문자 화면을 업로드하세요
      </p>
    </div>
  );
}
